import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import {
  fetchSetupStepsError,
  fetchSetupStepsSuccess,
  toggleDismissError,
  toggleDismissSuccess,
} from './actions'
import { FETCH_BASIC_SETUP_ASYNC, TOGGLE_DISMISS_ASYNC } from './constants'

const fetchSetupStepsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    // eslint-disable-next-line ironscales/fetch-selected-company-filter-guard -- the setup-steps badge lives in the navigation profile menu (an ALWAYS_ON epic key), so it must follow the company filter on every route, not one page
    ofType(FETCH_BASIC_SETUP_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS),
    mergeMap(() => {
      const companyFilter = selectCompanyFilter(state$.value)
      return api.accounts.getSetupSteps(companyFilter?.value).pipe(
        mergeMap((response) => of(fetchSetupStepsSuccess(response))),
        catchError((error) => of(epicsErrorHandler(fetchSetupStepsError, error, [400]))),
        takeUntil(action$.pipe(ofType(FETCH_BASIC_SETUP_ASYNC.CANCEL)))
      )
    })
  )

const toggleDismissEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(TOGGLE_DISMISS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.accounts
        .dismissStep(state$.value.partnerOptions.selectedCompany?.value, action.payload.body)
        .pipe(
          map(() => toggleDismissSuccess(action.payload.body)),
          catchError((error) => of(epicsErrorHandler(toggleDismissError, error))),
          takeUntil(action$.pipe(ofType(TOGGLE_DISMISS_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpicsIsolated(fetchSetupStepsEpic, toggleDismissEpic)
